import { member123, member234, member345, member456 } from './member';
export var leaderboards = [{
  id: 'global',
  name: '',
  relative: [{
    memberCount: 1,
    members: [member456, member123],
    myRank: true,
    points: 90000000,
    rank: 10000
  }, {
    memberCount: 1,
    members: [member234, member234, member234, member234],
    myRank: false,
    points: 35591,
    rank: 5
  }, {
    memberCount: 1,
    members: [member345, member234],
    myRank: false,
    points: 9983,
    rank: 6
  }],
  top: [{
    memberCount: 1,
    members: [member345],
    myRank: true,
    points: 90000,
    rank: 1
  }, {
    memberCount: 1,
    members: [member234],
    myRank: false,
    points: 35591,
    rank: 2
  }, {
    memberCount: 1,
    members: [member123],
    myRank: false,
    points: 9983,
    rank: 3
  }],
  member: member456
}, {
  id: '4',
  name: 'Super Long Leaderboard',
  relative: [{
    memberCount: 1,
    members: [member234],
    myRank: false,
    points: 90000,
    rank: 1
  }, {
    memberCount: 1,
    members: [member123],
    myRank: false,
    points: 35591,
    rank: 2
  }, {
    memberCount: 1,
    members: [member345],
    myRank: true,
    points: 9983,
    rank: 3
  }],
  top: [{
    memberCount: 1,
    members: [member234],
    myRank: false,
    points: 90000,
    rank: 1
  }, {
    memberCount: 1,
    members: [member345],
    myRank: false,
    points: 35591,
    rank: 2
  }, {
    memberCount: 1,
    members: [member123],
    myRank: true,
    points: 9983,
    rank: 3
  }],
  member: member456
}, {
  id: '5',
  name: 'Long Leaderboard',
  relative: [{
    memberCount: 1,
    members: [member345, member123],
    myRank: true,
    points: 90000,
    rank: 4
  }, {
    memberCount: 1,
    members: [member234, member234, member234, member234],
    myRank: false,
    points: 35591,
    rank: 5
  }, {
    memberCount: 1,
    members: [member345, member234],
    myRank: false,
    points: 9983,
    rank: 6
  }],
  top: [{
    memberCount: 1,
    members: [member345],
    myRank: true,
    points: 90000,
    rank: 1
  }, {
    memberCount: 1,
    members: [member234],
    myRank: false,
    points: 35591,
    rank: 2
  }, {
    memberCount: 1,
    members: [member123],
    myRank: false,
    points: 9983,
    rank: 3
  }],
  member: member456
}];